import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { DRIFT_ALERTS_QUERY_KEY } from "./constants";
import type { DriftAlertsResponse } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. Lists OPEN (unresolved)
 * drift alerts only; the API endpoint filters `resolved_at IS NULL`.
 */
async function fetchDriftAlerts(limit: number, offset: number): Promise<DriftAlertsResponse> {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  return httpClient<DriftAlertsResponse>(
    `/api/admin/subscriptions/drift-alerts?${params.toString()}`,
  );
}

export function useDriftAlertsList(limit: number, offset: number) {
  return useQuery({
    queryKey: [...DRIFT_ALERTS_QUERY_KEY, limit, offset] as const,
    queryFn: () => fetchDriftAlerts(limit, offset),
    // Keep the current page visible while the next one loads — no
    // flash of skeleton when paging through the queue.
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
